
import Vue from 'vue';
import axios from 'axios';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const axiosApi = function (parma, url) {
  let params = Object.assign(
    {"jsonrpc":"2.0","params":[],},
    parma)
  const config = {
    baseURL: "/api",
    url,
    method: "post",
    headers: { "Content-Type": "application/json-rpc" },
    data: params,
  };

  const _axios = axios.create(config);

  _axios.interceptors.request.use(
    (config) => {
      // Do something before request is sent
      return config;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    },
  );

  // Add a response interceptor
  _axios.interceptors.response.use(
    (response) => {
      // Do something with response data
      // let resData = {
      //   data0x: response.data.result,
      //   data: parseInt(response.data.result, 16),
      //   id: response.data.id
      // }

      return response.data.result;
    },
    (error) => {
      // Do something with response error
      return Promise.reject(error);
    },
  );

  return _axios();
}



Plugin.install = function (Vue, options) {
  // Vue.axios = _axios;
  // window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    $http: {
      get() {
        return axiosApi;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
